module.exports = __webpack_public_path__ + "fonts/apercu-light-pro.ac5e5be.woff2";